export function HeroSection() {
  return (
    <section className="flex items-center justify-center min-h-[50vh] bg-white px-6">
      <div className="text-center max-w-2xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-semibold text-[#002B5B] mb-3">
          Empecemos, ¿qué tema quieres revisar?
        </h1>
        <p className="text-base text-[#002B5B]/60">
          Estoy aquí para ayudarte con tus consultas jurídicas.
        </p>
      </div>
    </section>
  );
}
